import { ProjectPublishingStage, ReviewProject } from '@platform/client/schemas';
import {
  OrganizationProfileLink,
  ProfileItem,
  ProfileItemLong,
  ProfileItemStrList,
  ProfileSection,
  ProfileTabContainer,
  ProfileValueColors,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { dateToDaysAgoString } from '../../../util/DateHelpers';
import { businessChallengeFullText } from '../../../util/TextHelpers';

export const DetailsTabContent = ({ projectData }: { projectData?: ReviewProject }) => {
  return (
    <ProfileTabContainer>
      <ProfileSection title='Project Details'>
        <OrganizationProfileLink
          organizationId={projectData?.organizationId}
          organizationName={projectData?.organizationName}
        />
        <ProfileItem label='Role' value={projectData?.roleType} />
        <ProfileItem label='Delivery Type' value={projectData?.deliveryType} />
        <PublishingStageItem
          publishingStage={projectData?.publishingStage}
          publishingStageDate={projectData?.publishingStageDate}
        />
        <ProfileItem label='Workload' value={projectData?.workload} />
        <ProfileItem
          label='Status Date'
          value={
            projectData?.publishingStageDate ? formatDateStr(projectData.publishingStageDate) : ''
          }
        />
        <ProfileItem label='Open to Team' value={projectData?.openToTeam ? 'Yes' : 'No'} />
        <ProfileItem
          label='Start Date'
          value={projectData?.startDate ? formatDateStr(projectData.startDate) : ''}
        />
        <ProfileItem
          label='Business Challenge'
          value={
            projectData?.businessType ?
              businessChallengeFullText(projectData.businessType, true)
            : null
          }
        />
        <ProfileItem
          label='End Date'
          value={projectData?.endDate ? formatDateStr(projectData.endDate) : ''}
        />
        <ProfileItemLong label='Planned Cohorts' value={projectData?.cohorts?.join('; ')} />
        <ProfileItem label='AI Suggested' value={projectData?.suggestedProject ? 'Yes' : 'No'} />
      </ProfileSection>
      <ProfileSection title='Match Preferences' columns={1}>
        <ProfileItem label='Timezone' value={projectData?.timezone} />
        <ProfileItemLong label='Languages' value={projectData?.language} />
        <ProfileItemLong label='Skills' value={projectData?.expertises} />
        <ProfileItemLong label='Description' value={projectData?.description} />
        <ProfileItemLong label='Goals' value={projectData?.goals} />
        <ProfileItemStrList label='Deliverables' value={projectData?.deliverables} />
        <ProfileItemLong label='Learning Outcomes' value={projectData?.learningOutcomes} />
        <ProfileItemLong
          label='Additional Requirements'
          value={projectData?.additionalRequirements}
        />
      </ProfileSection>
    </ProfileTabContainer>
  );
};

const PublishingStageItem = ({
  publishingStage,
  publishingStageDate,
}: {
  publishingStage?: ProjectPublishingStage;
  publishingStageDate?: string;
}) => {
  let value = '';
  let color: ProfileValueColors = 'default';
  if (publishingStage) {
    value = publishingStage;
    if (publishingStage === 'published') {
      color = 'success';
    } else if (
      publishingStageDate &&
      (publishingStage === 'review' || publishingStage === 'revision_requested')
    ) {
      value += ` (${dateToDaysAgoString(publishingStageDate)})`;
      color = 'warning';
    }
  }
  return <ProfileItem label='Project Status' value={value} color={color} />;
};
